class SlideActionsDocumentList {

    constructor() {

        this._slideActionsData = new SlideActionsData();
        this._loadPartialsTemplates();

    }

    _loadPartialsTemplates() {

        Handlebars.registerPartial("slideActionsDocumentList", $("#slideActionsDocumentList").html());

    }

    _enableHandlers() {

        $("div.slide-actions-list-button").off("click.toggleSlideButton").on("click.toggleSlideButton", this._onToggleSlideActionsList.bind(this));
        $("div.slide-actions-list").off("click.actionButton").on("click.actionButton", "div.slide-action-button", this._onClickButton.bind(this));

    }

    _onToggleSlideActionsList(event) {
        event.preventDefault();
        event.stopPropagation();

        // little hack to prevent overlaping
        // https://iseazy-engage.atlassian.net/browse/IZE-1210
        document
            .querySelectorAll('.slide-action-button[data-action=shareChat]')
            .forEach(el => el.remove())

        function _onAnimationEnd() {
            $actionsList.addClass("is-displaced");
        }

        const $this = $(event.currentTarget);
        const documentId = $this.data("document");
        const $documentItem = $(".bf-smart-list.list[data-document=" + documentId + "]");
        const $actionsList = $(".slide-actions-list[data-document=" + documentId + "]");
        const $actionsListButton = $actionsList.find(".slide-action-button");
        const buttonWidth = $actionsListButton.width();

        if ($actionsList.hasClass("is-displaced")) {
            $actionsList.removeClass("is-displaced");
            $documentItem.animate({left: 0});
        } else {
            $documentItem.animate({left: -buttonWidth * $actionsListButton.length}, _onAnimationEnd);
        }
    }

    _onClickButton(event) {

        const $this = $(event.currentTarget);
        const userWorldId = $this.data("document");
        const action = $this.data("action");
        let documentId = $this.data("document");
        const documentActions = this._slideActionsData.getDocumentActions();

        switch(action) {

            case documentActions.LIKE_ACTION:
                this._likeAction(documentId);
                break;

            case documentActions.FAVOURITE_ACTION:
                this._favouriteAction(documentId);
                break;

            case documentActions.COMMENT_ACTION:
                this._documentAction(documentId, documentationScreenController.COMMENT_OPTION);
                break;

            case documentActions.RATE_ACTION:
                this._documentAction(documentId, documentationScreenController.RATE_OPTION);
                break;

            case documentActions.SHARE_ACTION:
                this._documentAction(documentId, documentationScreenController.SHARE_OPTION);
                break;

            case documentActions.SHARE_CHAT_ACTION:
                this._shareChatAction(documentId);
                break;

        }

    }

    _likeAction(documentId) {

        const $gifDocumentLiked = $("#gif-document-liked-" + documentId + "-standar");

        // Prevenir error al pulsar varias veces seguidas y rapido sobre el boton de like.
        if ($gifDocumentLiked.children().length === 0) {
            docSocket.emit(SocketEvents.SET_LIKE_REQUEST(), JSON.stringify({document_id: documentId}));
        }

    }

    _favouriteAction(documentId) {
        docSocket.emit(SocketEvents.SET_FAVORITE_REQUEST(), JSON.stringify({document_id: documentId}));
    }

    _documentAction(documentId, option) {
        const document = documentationScreenController.getDocument(documentId);
        const folder = documentationScreenController.getCurrentFolder();

        if(document.type === 'PATH' && ['share', 'comment'].includes(option)) {
            documentationScreenController.openDocumentPathDetailsFile(document, folder, option);

            return;
        }

        documentationScreenController.openDocumentDetailsFile(document, folder, option);
    }

    _shareChatAction(documentId) {

        const folder = documentationScreenController.getCurrentFolder();
        documentationScreenController.documentationShareChat.initChatShareSection(folder.id, documentId);

    }

    initialize() {
        this._enableHandlers();
    }

}